exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog .v-card__text[data-v-e41e288a]{padding:0!important}.v-dialog .v-alert[data-v-e41e288a]{border-radius:0!important}.v-dialog[data-v-e41e288a],.v-dialog .v-card__text[data-v-e41e288a]{overflow:hidden!important}", ""]);

// exports
